<template>
    <div class="global-tooltip" v-if="visible" :style="{'top': top + 'px', 'left': left + 'px'}" style="position: fixed">
        <p class="tooltip-text">{{text}}</p>
    </div>
</template>

<script>
    export default {
        name: "global-tooltip",
        data() {
            return {
                top:0,
                left:0,
                visible: false,
                text: null,
                isHiding: false
            }
        },
        methods: {
            showTooltip(top, left, text) {
                if (!text || text.length == 0)
                    return;

                this.top = top;
                this.left = left;
                this.text = text;
                this.visible = true;
                this.isHiding = false;
            },
            hideTooltip() {
                if (this.isHiding) {
                    this.isHiding = false;
                    return;
                }

                this.isHiding = true;

                var self = this;
                setTimeout(function() {
                    if (self.isHiding) {
                        self.isHiding = false;
                        self.visible = false;
                    }
                }, 300);
            }
        }
    }
</script>

<style scoped>

    .global-tooltip {
        z-index: 300;
        color: white;
        background-color: #1A2229;
        border: 1px solid rgba(0, 255, 169, 1);
        overflow: hidden;
        display: inline-block;
        font-family: "Titillium Web";
        max-width: 400px;
    }

    .tooltip-text {
        padding:5px;
        font-size: 11px;
        margin-bottom: 0;
        word-wrap: break-word;
    }

</style>



// WEBPACK FOOTER //
// src/components/tooltip/GlobalTooltip.vue